import { SearchResult } from "@/components/Search";
import { FrameworkHierarchy } from "@/contexts/entities/EntitiesContext";
import { EventType, handleEvent } from "./base";

export const handleSearchBarView = ({
  isOpened,
  searchTerm,
  searchResults,
}: SearchBarClickParams) => {
  const eventProperties = {
    action: isOpened ? "start" : "exit",
    search_term: searchTerm,
    search_results: searchResults,
  };
  handleEvent(EventType.SearchBar, eventProperties);
};

export const handleSearchResultClick = (params: SearchResultClickParams) => {
  const eventProperties = getSearchClickProperties(params);
  handleEvent(EventType.SearchClick, eventProperties);
};

export const handleSearchResults = (params: SearchResultClickParams) => {
  const eventProperties = getSearchResultsProperties(params);
  handleEvent(EventType.SearchResults, eventProperties);
};

type SearchBarClickParams = {
  isOpened: boolean;
  searchTerm?: string;
  searchResults?: SearchResult[];
};

export type SearchResultClickParams = {
  entityHierarchy: FrameworkHierarchy;
  searchTerm: string;
  searchResult: SearchResult;
  searchResults: SearchResult[];
};

export const getSearchClickProperties = ({
  entityHierarchy,
  searchTerm,
  searchResult,
  searchResults,
}: SearchResultClickParams) => {
  const rank =
    1 + searchResults.findIndex((result) => result.id === searchResult.id);
  const level = entityHierarchy.subCompetency ? "subcompetency" : "competency";
  return {
    rank,
    search_term: searchTerm,
    name: searchResult.name,
    level,
    search_results: searchResults,
  };
};

export const getSearchResultsProperties = ({
  entityHierarchy,
  searchTerm,
  searchResult,
  searchResults,
}: SearchResultClickParams) => {
  const rank =
    1 + searchResults.findIndex((result) => result.id === searchResult.id);
  const level = entityHierarchy.subCompetency ? "subcompetency" : "competency";
  return {
    rank,
    search_term: searchTerm,
    name: searchResult.name,
    level,
    search_results: searchResults,
  };
};

export const handleEmbeddedSearchRequest = ({
  context,
  searchTerm,
  searchResults,
}: EmbeddedSearchRequestParams) => {
  const eventProperties = {
    context,
    search_term: searchTerm,
    search_results: searchResults,
  };
  handleEvent(EventType.SearchBar, eventProperties);
};

type EmbeddedSearchRequestParams = {
  context: string;
  searchTerm: string;
  searchResults?: SearchResult[];
};
